import { postApi } from '@/api';

export class HttpApiPropertyRepository {
  searchViolations(cityId, options) {
    return postApi(`/v1/cities/${encodeURIComponent(cityId)}/violations/search`, options);
  }

  exportViolations(cityId, options) {
    return postApi(`/v1/cities/${encodeURIComponent(cityId)}/violations/export`, options);
  }

  pendingViolationLetters(cityId, options) {
    return postApi(`/v1/cities/${encodeURIComponent(cityId)}/violations/pending-letters`, options);
  }
}
